<template>
  <div
    class="home122-wrap"
    v-loading="loading.value"
    :element-loading-text="loading.text"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    id="homeWarp"
  >
    <div class="musicbox-content-wrap">
      <div class="img-header" id="header">
        <img
          src="../../../assets/image/head122.png"
          :style="{
            '--length': title.length + 5
          }"
          alt=""
        />
        <div class="head-title">{{ title }}</div>
      </div>

      <div class="device-box" v-if="deviceList.length">
        <div
          class="flagPoint"
          v-for="(pointItem, pointIndex) in floorFlagList"
          :id="pointItem"
          :key="pointItem"
          :style="{
            '--top': `${(pointIndex + 1) * 180 + 30 * pointIndex - 10}px`
          }"
        ></div>

        <div
          v-for="(item, index) in deviceList"
          class="device-box-item"
          :id="item.id"
          :key="index"
          :style="{
            '--width': itemWidth,
            '--per': percentNum
          }"
          @click="chooseSn(item.sn, item.state, item.deviceType, item.runMode)"
        >
          <!-- :class="item.state | stateClass(true)" -->
          <div
            class="device-header"
            :class="
              item.state
                ? Object.keys(flickerDict).includes(item.state.toString())
                  ? flickerDict[item.state]
                  : ''
                : ''
            "
            :id="`header${item.id}`"
            :style="{
              '--color': getState(item.runstate, item.state).c2
            }"
          >
            <span style="z-index: 2">
              {{ item.name }}({{ getState(item.runstate, item.state).t }})
            </span>
          </div>
          <div class="device-container">
            <img :src="item.imgSrc" alt="" />
            <div class="device-text">
              <span
                :style="{
                  color: item.state == -1 ? 'rgba(159, 159, 159, 0.5)' : '#fff'
                }"
                class="text-ellipsis"
              >
                {{ item.dynamicInfoMap.location_desc }}
                <!-- {{ item.deviceType }} -->
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <el-empty :image-size="200" description="暂无设备"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { jsPlumb } from 'jsplumb';
import { windowOpen } from '@/utils/utils';
import { isArray } from '@/utils/is';
import { mapState } from 'vuex';
import { pointState } from '@/utils/dict';
import { getOptions } from '@/utils/deviceUtils/state';
import { getDeviceTypeImg } from '@/utils/deviceUtils';

import { isEmpty } from '@/utils/is';
import { extDevice, isDevice } from '@/utils/deviceUtils';

import screenfull from 'screenfull';
import ctt from '@/utils/const';

function treeDataRecu(count, result, arr, childNodes = []) {
  const leafNodes = [];
  let copyChildNodes;
  count++;
  if (isArray(arr)) {
    arr.forEach(e => {
      copyChildNodes = JSON.parse(JSON.stringify(childNodes));
      if (e.nodeType === 1) {
        copyChildNodes.push({
          name: e.name,
          id: e.id
        });
        treeDataRecu(count, result, e.children, JSON.parse(JSON.stringify(copyChildNodes)));
      } else {
        if (count === 1) {
          result.push({ childNodes: [{ name: e.name, id: e.id }], leafNodes: [] });
        } else {
          leafNodes.push(e);
        }
      }
    });
  }
  if (count !== 1 && leafNodes.length > 0) {
    result.push({ childNodes: copyChildNodes, leafNodes });
  }
}

function setDeviceImg(device) {
  device.forEach(item => {
    const imgInfo = getDeviceTypeImg(item.deviceType);
    item.imgSrc = imgInfo.picture;
  });
}

export default {
  data() {
    return {
      list: [], // 选中机构的设备
      deviceList1: [],
      showDom: false,
      loading: {
        value: false,
        text: '加载中, 请耐心等待'
      },
      jsPlumbInstance: '', //jsPlumb实例
      floorFlagList: [],
      itemWidth: '', // 设备盒子宽度,
      linsNumOptions: [
        {
          title: '每行2个',
          key: 2
        },
        {
          title: '每行4个',
          key: 4
        },
        {
          title: '每行6个',
          key: 6
        }
      ],
      percentNum: '15%',
      // 闪烁报警
      flickerDict: {
        1: 'early-alarm',
        2: 'pulse-alarm',
        3: 'pulse-alarm'
      },
      title: ''
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    ...mapState('device', ['monitorMenuActive', 'deviceTypeInfo', 'monitorConfig']),
    ...mapState('app', ['menuCollapse']),
    ...mapState('socket', ['deviceIdMap']),

    linesNum() {
      return this.monitorConfig.deviceTreeLineNum;
    },

    deviceList() {
      const count = 0;
      const result = [];
      const allDevice = [];
      treeDataRecu(count, result, this.$store.state.socket.deviceTree);
      result.forEach(item => {
        allDevice.push(...item.leafNodes);
      });
      setDeviceImg(allDevice);

      const typeOrder = {};
      let index = 0;

      allDevice.forEach(item => {
        if (typeOrder[item.deviceType] === undefined) {
          typeOrder[item.deviceType] = index++;
        }
      });

      const sortedArr = [...allDevice].sort(
        (a, b) => typeOrder[a.deviceType] - typeOrder[b.deviceType]
      );

      return sortedArr;
    },

    showOpenWindowButton() {
      return !window.name;
    }
  },
  watch: {
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      immediate: true
    },
    linesNum: 'lineNumsSetHandle',
    menuCollapse: {
      deep: true,
      //   immediate: true,
      handler() {
        setTimeout(() => {
          this.handleResize();
        }, 200);
      }
    }
  },

  methods: {
    getState(runstate, state) {
      return getOptions(runstate, state);
    },
    drawLines() {
      let _this = this;
      let jsPlumbConnectOptions = {
        isSource: true,
        isTarget: true,
        anchor: ['Bottom', 'Top'],
        connector: ['Flowchart'], // 连线类型  flowChart 90°转角线
        endpoint: 'Blank', // 端点类型
        paintStyle: { stroke: '#039ae2', strokeWidth: 2.5 } // 连线样式
      };

      let jsPlumbConnectOptions1 = {
        isSource: true,
        isTarget: true,
        // 动态锚点、提供了4个方向 Continuous、AutoDefault
        anchor: ['Bottom', 'Top'],
        connector: ['Straight'], // 连线类型  flowChart 90°转角线
        endpoint: 'Blank', // 端点类型
        paintStyle: { stroke: '#039ae2', strokeWidth: 2.5 } // 连线样式
      };

      this.$nextTick().then(() => {
        jsPlumb.ready(() => {
          _this.jsPlumbInstance = jsPlumb.getInstance({
            Container: document.getElementById('homeWarp')
          });

          _this.jsPlumbInstance.connect(
            { source: 'header', target: this.floorFlagList[0] },
            jsPlumbConnectOptions1
          );

          for (let i = 0; i < _this.floorFlagList.length; i++) {
            const current = _this.floorFlagList[i];
            const next = i < _this.floorFlagList.length - 1 ? _this.floorFlagList[i + 1] : null;
            if (next) {
              _this.jsPlumbInstance.connect(
                { source: current, target: next },
                jsPlumbConnectOptions
              );
            }
          }

          // 开始节点间的连线
          _this.deviceList.forEach((item, _index) => {
            // _this.jsPlumbInstance.connect(item.line, jsPlumbConnectOptions);
            if (this.lastFloorDevice.length === 1 && item.id === this.lastFloorDevice[0].id) {
              _this.jsPlumbInstance.connect(item.line, jsPlumbConnectOptions1);
            } else {
              _this.jsPlumbInstance.connect(item.line, jsPlumbConnectOptions);
            }
          });
        });
        _this.jsPlumbInstance.repaintEverything(); // 重绘
      });
    },
    monitorMenuActiveChange(n) {
      if (isEmpty(n)) return;
      let res;
      let root = null;
      if (isDevice(n.nodeType)) {
        const device = this.deviceIdMap[n.id];
        root = this.deviceIdMap[device.parentId];
      } else {
        root = this.deviceIdMap[n.id];
      }
      res = extDevice([root]);

      //   this.title = root?.name;
      this.list.splice(0, Infinity, ...res);
      //   console.log('this.list', this.list);

      this.title = '设备监控';
    },
    openNewWindow() {
      windowOpen(this.$route, this.$route.name);
    },
    screenfullToggle() {
      if (screenfull.isFullscreen) {
        screenfull.exit();
      } else {
        screenfull.request(document.getElementById('appContent'));
      }
    },
    showLoading() {
      this.loading.value = true;
    },
    hideLoading() {
      if (!this.loading) return;
      setTimeout(() => {
        this.loading.value = false;
      }, 200);
    },

    setDeviceListLinesHandle() {
      this.showLoading();
      this.targetIds = [];
      this.floorFlagList = [];

      this.deviceList.forEach((item, index) => {
        let key = Math.trunc(index / this.linesNum);
        item.id = `fl_${key}_${item.sn}`;
        this.targetIds.push(item.id);

        if (key > 0) {
          this.floorFlagList.push(`fl_${key}`);
        }
      });

      this.floorFlagList = Array.from(new Set(this.floorFlagList));
      this.floorFlagList.unshift('header');

      this.deviceList.forEach((item, index) => {
        let key = Math.trunc(index / this.linesNum);
        item.line = {
          source: this.floorFlagList[key],
          target: this.targetIds[index]
        };
      });

      this.floorFlagList.shift();

      let lastFlagKey = this.floorFlagList[this.floorFlagList.length - 1];
      this.lastFloorDevice = this.deviceList.filter(item => {
        return item.id.includes(lastFlagKey);
      });

      setTimeout(() => {
        this.showDom = true;
        this.drawLines();
      }, 200);

      setTimeout(() => {
        this.hideLoading();
      }, 200);
    },

    handleResize() {
      if (!this.jsPlumbInstance) return;
      this.jsPlumbInstance.repaintEverything(); // 重绘
    },

    delAllLine() {
      this.jsPlumbInstance.deleteEveryConnection(); // 删除所有连线
      this.jsPlumbInstance.deleteEveryEndpoint(); //删除所有节点
    },

    chooseSn(sn, state, deviceType, runMode) {
      if (
        runMode === ctt.MONITOR_DEVICE &&
        (state === undefined || state === ctt.POINT_STATE_UNCONNECT)
      ) {
        this.$message({ type: 'info', message: pointState[state] });
      } else {
        if (sn !== this.$route.params.sn) {
          this.$router.push({
            name: 'Realdata',
            params: { sn, deviceType }
          });
        }
      }
    },
    lineNumsSetHandle() {
      this.delAllLine();
      this.setDeviceListLinesHandle();
      this.countItemSizeHandle();
    },
    countItemSizeHandle() {
      this.itemWidth = this.itemWidthDict[this.linesNum];
      this.percentNum = this.percentDict[this.linesNum];
    }
  },

  mounted() {
    this.itemWidthDict = {
      2: 2,
      4: 4,
      6: 6
    };
    this.percentDict = {
      2: '45%',
      4: '24%',
      6: '15%'
    };

    this.countItemSizeHandle();

    this.setDeviceListLinesHandle();

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.hideLoading();
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped lang="scss">
.home122-wrap {
  height: 100%;
  position: relative;
  overflow-y: auto;
  @include scrollar-style-thin;

  &::after {
    content: '';

    height: 20px;
  }

  .text-ellipsis {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; /* 限制行数 */
    -webkit-box-orient: vertical; /* 垂直排列布局中的盒子 */
  }

  .musicbox-header {
    margin-top: 40px;
    color: $primary-text-color;
    margin-bottom: 15px;
    height: 20px;
    background-size: 100% 100%;
    position: relative;
    user-select: none;

    .handler {
      position: absolute;
      right: 20px;
      top: 20px;
      .icon-dakai {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .musicbox-content-wrap {
    margin-top: 60px;

    height: calc(100% - 60px);
    .img-header {
      margin-bottom: 40px;
      text-align: center;
      position: relative;
      //   min-width: 224px;

      img {
        min-width: 224px;
        width: calc(var(--length) * 20px);
        max-width: 480px;
        // width: 224px;
        height: 76px;
      }
      .head-title {
        max-width: 450px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // transform: translateY(-50%);
        color: #fff;
        font-size: 25px;
        font-weight: bold;
      }
    }
    .device-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;
      position: relative;
      padding: 0 25px;

      &-item {
        cursor: pointer;
        display: inline-block;
        border-radius: 10px;
        // width: calc(15% - 30px * 3 / 4);
        // width: calc(24% - 30px * 3 / 4);

        width: calc(var(--per) - 30px * calc(var(--width) - 1) / var(--width));
        // height: 10vw;
        height: 180px;
        box-sizing: border-box;
        .device-header {
          padding-left: 20px;
          font-size: 18px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border-radius: 10px 10px 0 0;
          height: 48px;
          line-height: 48px;
          color: #f5f5f5;
          background: var(--color);
          position: relative;
        }

        // 报警闪烁
        .pulse-alarm {
          animation: pulse 1.5s infinite;
          background: rgba(255, 62, 68) !important;
        }

        @keyframes pulse {
          0% {
            opacity: 0.6;
            box-shadow: 0 0 0 0 rgba(255, 62, 68, 0.7);
            // box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.7);
          }
          70% {
            opacity: 1;
            box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
          }
          100% {
            opacity: 0.6;
            box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
          }
        }

        // 预警闪烁
        .early-alarm {
          animation: earlyPulse 1.5s infinite;
          background: rgba(255, 86, 32) !important;
        }

        @keyframes earlyPulse {
          0% {
            opacity: 0.6;
            box-shadow: 0 0 0 0 rgba(255, 86, 32, 0.7);
          }
          70% {
            opacity: 1;
            box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
          }
          100% {
            opacity: 0.6;
            box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
          }
        }

        .device-container {
          height: calc(100% - 48px);
          padding: 10px;
          box-sizing: border-box;
          border: 2px solid #039ae2;
          background-color: #29475f;
          border-radius: 0 0 10px 10px;
          border-top: none;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 30%;
            height: 90%;
            object-fit: scale-down;
          }
          .device-text {
            width: 35%;
            text-align: right;
            span {
              @include state-textstyle;
              //   display: block;
            }
          }
        }
      }
      .flagPoint {
        height: 1px;
        width: 1px;
        background: #039ae2;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: var(--top);
      }
    }
  }
}
</style>
